<script>
    import { t } from '../i18n.js'
    import { isMobile } from '../store/stores.js'

    const bringDataInstructions = [
        'dashboard.guide-bring-data-step-one',
        'dashboard.guide-bring-data-step-two',
        'dashboard.guide-bring-data-step-three',
        'dashboard.guide-bring-data-step-four'
    ]
    const importInstructions = [
        'dashboard.guide-use-data-step-one',
        'dashboard.guide-use-data-step-two',
        'dashboard.guide-use-data-step-three'
    ]
</script>

<div class="bg-light-navy py-24">
    <div class="container max-w-5xl text-white grid grid-cols-1 md:grid-cols-2 {$isMobile ? '' : 'after:block after:absolute after:left-[50%] after:top-20 after:bottom-20 after:w-0.5 after:bg-light-blue relative inline-block'}">
        
        <div class="mx-4 max-w-sm justify-self-center">
            <h2 class="text-2xl mb-4 after:block after:absolute after:-inset-2 after:top-9 after:left-0 after:w-32 after:bg-light-blue relative inline-block">
                {$t('dashboard.guide-use-data-title')}
            </h2>
            <ol>
                {#each importInstructions as item , i}
                    <li class="flex my-8">
                        <div class="mr-4">
                            <div class="flex justify-center items-center text-xl text-center w-10 h-10 border-2 rounded-[50%]">{i + 1}</div>
                        </div>
                        <p>{$t(item)}</p>
                    </li>
                {/each}
            </ol>
        </div>
        <div class="md:mb-none mb-16 mx-4 max-w-sm justify-self-center {$isMobile ? 'pb-8 border-b border-lightest-blue' : ''}">
            <h2 class="text-2xl mb-4 after:block after:absolute after:-inset-2 after:top-9 after:left-0 after:w-32 after:bg-light-blue relative inline-block">
                {$t('dashboard.guide-bring-data-title')}
            </h2>
            <ol>
                {#each bringDataInstructions as item , i}
                    <li class="flex my-8">
                        <div class="mr-4">
                            <div class="flex justify-center items-center text-xl text-center w-10 h-10 border-2 rounded-[50%]">{i + 1}</div>
                        </div>
                        <p>{$t(item)}</p>
                    </li>
                {/each}
            </ol>
        </div>
    </div>
</div>